import './style.scss';
import Nav from "./components/Nav/Nav";
import {Link} from "react-router-dom";

const Header = () => {

    return (
        <>
        <div className='header'>
            <Link to={'/'} className='title'>
                <p>DANIEL NAHUM</p>
            </Link>
        </div>
        <Nav/>
        </>
    )
}

export default Header;